// src/api/healthcare/ClinikoSyncApi.ts
/**
 * @file Cliniko Sync API functions
 * @module api/clinikoSyncApi
 */

import { ENV } from '../../../config/runtimeEnv';
import { ClinikoSyncResponse } from "../../../types/appointments/AppointmentSettingsTypes";
import { http } from "../../../lib/http/client";

const API_BASE_URL = ENV.VITE_HEALTHCARE_SERVER;

/**
 * Sync appointment types from Cliniko
 */
export const syncAppointmentTypes = async (): Promise<ClinikoSyncResponse> => {
	const response = await http.post(
		`${API_BASE_URL}/practitioner/cliniko/sync-appointment-types`,
		{},
		{
			timeout: 300000, // 5 minutes
		}
	);
	return response.data;
};

/**
 * Sync appointments from Cliniko
 */
export const syncAppointments = async (sinceDate?: string): Promise<ClinikoSyncResponse> => {
	const response = await http.post(
		`${API_BASE_URL}/practitioner/cliniko/sync-appointments`,
		{ since_date: sinceDate },
		{
			timeout: 600000, // 10 minutes
		}
	);
	return response.data;
};

/**
 * Sync practitioner schedules from Cliniko
 */
export const syncSchedules = async (): Promise<ClinikoSyncResponse> => {
	const response = await http.post(
		`${API_BASE_URL}/practitioner/cliniko/sync-schedules`,
		{},
		{
			timeout: 300000, // 5 minutes
		}
	);
	return response.data;
};

/**
 * Perform full sync from Cliniko
 */
export const fullSync = async (sinceDate?: string): Promise<ClinikoSyncResponse> => {
	const response = await http.post(
		`${API_BASE_URL}/practitioner/cliniko/full-sync`,
		{ since_date: sinceDate },
		{
			timeout: 600000, // 10 minutes
		}
	);
	return response.data;
};